import Link from '@risksmart-app/components/src/link';
import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { LinkItem } from './useLinkArrayField';
import styles from './useLinkArrayField.module.css';

// Number of links shown before the list collapses behind a "Show X more"
// toggle. The toggle only appears when there are more links than this.
const COLLAPSED_COUNT = 1;

/**
 * Renders a list of link items, collapsed to the first {@link COLLAPSED_COUNT}
 * by default with a "Show X more" / "Show less" toggle when there are more.
 * Each line truncates with an ellipsis (full label available via `title`).
 */
const LinkArrayCell: FC<{ links: LinkItem[] }> = ({ links }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const hasOverflow = links.length > COLLAPSED_COUNT;
  const visibleLinks = expanded ? links : links.slice(0, COLLAPSED_COUNT);

  return (
    <div>
      {visibleLinks.map((link, i) => (
        <div key={i} className={styles.linkLine} title={link.label}>
          <Link href={link.url}>{link.label}</Link>
        </div>
      ))}
      {hasOverflow && (
        <button
          type={'button'}
          onClick={() => setExpanded((prev) => !prev)}
          className={
            'mt-3 cursor-pointer rounded-full border-none bg-transparent p-2 text-[13px] font-semibold text-grey650 transition-colors hover:bg-grey150'
          }
        >
          {expanded
            ? t('linkArrayField.showLess')
            : t('linkArrayField.showMore', {
                count: links.length - COLLAPSED_COUNT,
              })}
        </button>
      )}
    </div>
  );
};

export default LinkArrayCell;
